import axios from 'axios';
import { BASE_URL_API } from '../../utils/constants';

axios.defaults.baseURL = `${BASE_URL_API}/api/`
axios.defaults.headers.common = {
    'accept': 'application/json',
    'Content-Type': 'application/json'
}

// Intercepteur : injecte automatiquement le token JWT sur chaque requête
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token-bahtb-secret');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Intercepteur : redirige vers login si token expiré (401 uniquement)
// On ne redirige PAS sur 403 car le backend retourne 403 pour mauvais credentials au login
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const isLoginEndpoint = error.config?.url?.includes('/login');
        if (error.response && error.response.status === 401 && !isLoginEndpoint) {
            localStorage.removeItem('token-bahtb-secret');
            localStorage.removeItem('valideUser');
            window.location.href = '/';
        }
        return Promise.reject(error);
    }
);

export default axios;